module.exports = __webpack_public_path__ + "img/desk2.72578123.png";